import React from 'react';
import { ButtonIconProps } from './types';
import { StyledButtonIcon } from './styled';

export const ButtonIcon: React.FC<ButtonIconProps> = ({
  onClick,
  buttonType = 'default',
  size = 'medium',
  disabled = false,
  className = '',
  buttonIcon,
  buttonText,
  ...rest
}) => {
  const onlyIcon = !buttonText;
  
  return (
    <StyledButtonIcon
      onClick={onClick}
      buttonType={buttonType}
      size={size}
      disabled={disabled}
      className={className}
      onlyIcon={onlyIcon}
      {...rest}
    >
      <div className="button-content">
        {buttonIcon && <span className="button-icon">{buttonIcon}</span>}
        {buttonText && <span className="button-text">{buttonText}</span>}
      </div>
    </StyledButtonIcon>
  );
};

export default ButtonIcon;
